"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.426 2.824C5.664 3.157 4.02 3.664 3 4.012a2.369 2.369 0 0 0-1.6 2.13c-.065 1.242-.149 3.484-.149 6.727 0 3.158.08 5.367.143 6.626.056 1.107 1.165 1.752 2.142 1.418a31.1 31.1 0 0 1 3.89-1.038V2.824Zm7.776 18.55a.684.684 0 0 1-.18-.045h-.002l-.006-.003-.026-.01a17.576 17.576 0 0 0-.508-.19 34.62 34.62 0 0 0-1.455-.486c-1.168-.361-2.697-.768-4.227-.985V2.76l.017-.132h.004l.009.002.03.004.116.017a32.042 32.042 0 0 1 1.946.368c1.17.258 2.71.663 4.282 1.263v17.091Zm1.373-.198c1.761-.334 3.404-.841 4.425-1.188a2.369 2.369 0 0 0 1.602-2.131c.064-1.241.148-3.483.148-6.726 0-3.158-.08-5.367-.143-6.627-.056-1.106-1.165-1.751-2.142-1.418a31.123 31.123 0 0 1-3.89 1.038v17.052ZM8.797 2.625l.017.002-.017.132v-.134Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgMap);
var _default = exports["default"] = Memo;